import { PluginListenerHandle } from '@capacitor/core';

export enum Outcome {
  InitialState,
  Succeeded,
  Failed,
  Canceled
}
export interface ParentHubStripePlugin {
  stripeInit(options: { publishableKey: string }): Promise<void>;
  initialiseCustomerSession(options: { ephemeralKey: string }): Promise<void>;
  findPaymentMethod(options: { paymentMethodId: string }): Promise<{
    paymentMethodId: string;
    cardBrand: string;
    cardLast4: string;
    cancelled: boolean;
  }>;
  choosePaymentMethod(options: { paymentMethodId: string }): Promise<void>;
  confirmPayment(options: {
    publishableKey: string;
    intentSecretKey: string;
    paymentMethodId: string;
  }): Promise<{ code: string; status: string; outcome: Outcome }>;
  clearCache(): Promise<void>;
  initialiseGooglePay(): Promise<{ canPayByGooglePay: boolean }>;
  payWithGooglePay(options: {
    publishableKey: string;
    intentSecretKey: string;
    totalPrice: number;
    currencyCode: string;
  }): Promise<{ paymentMethodId?: string; status: string; outcome?: number; code: any }>;
  initialiseApplePay(): Promise<{ canPayByApplePay: boolean }>;
  payWithApplePay(options: {
    publishableKey: string;
    intentSecretKey: string;
    totalPrice: number;
    currencyCode: string;
    schoolName: string;
  }): Promise<{ status: string; outcome?: number; code: any }>;
  continueApplePayWithIntent(options: { intentSecretKey: string }): Promise<void>;

  addListener(
    eventName: 'paymentMethodChanged',
    listenerFunc: (paymentMethod: { methodId: string; cardBrand: string; cardLast4: string }) => void
  ): Promise<PluginListenerHandle> & PluginListenerHandle;

  addListener(
    eventName: 'applePayIntentRequired',
    listenerFunc: () => void
  ): Promise<PluginListenerHandle> & PluginListenerHandle;
  removeAllListeners(): Promise<void>;
}
